var Dialog = {
	afterFunc:null,
	flatTimer:null,
	hinted:{},

	init: function() {
		$("#panels").append($("<div id='dialog_overlay'></div>"));
		$("#panels").append($("<div id='dialogs'></div>"));
		Tab.setGroup("dialogs", "+", 0);
		Tab.groups["dialogs"].disable();
	},

	message: function(icon, html, button_title, after) {
		var od = $("#dialog");
		if (od != undefined) od.remove();
		Dialog.afterFunc = after;

		$("#dialogs").append(TPL.render("dialog-main", {message:html, button:button_title, "icon":icon, "hasIcon": (icon != "" ? true : false)}));

		$("#dialog").css("left", $("body").width() * 0.5 - ($("#dialog").width() + 50) * 0.5);
		$("#dialog").css("opacity", "1");
		$("#dialog").css("top", "80px");
	},

	select: function(icon, html, help, opts, after) {
		var od = $("#dialog");
		if (od != undefined) od.remove();
		Dialog.afterFunc = after;

		$("#dialogs").append(TPL.render("dialog-multiopt", {message:html, options:opts, "icon":icon, "help":help, "clickEvent": "on" + Events.pointer.up}));

		$("#dialog").css("left", $("body").width() * 0.5 - ($("#dialog").width() + 50) * 0.5);
		$("#dialog").css("opacity", "1");
		$("#dialog").css("top", "80px");
	},

	route: function(name, thumb, category, id, help, go, start, finish, after) {
		var od = $("#dialogroute");
		if (od != undefined) od.remove();
		Dialog.afterFunc = after;

		$("#dialog_overlay").show();

		$("#dialogs").append(TPL.render("dialog-routeopt", {"placeName":name, "thumb":thumb, "category":category, "id":id, "go":go, "start":start, "finish":finish, "help":help, "clickEvent": "on" + Events.pointer.up}));

		$("#dialogroute").css("left", $("body").width() * 0.5 - ($("#dialogroute").width() + 50) * 0.5);
		$("#dialogroute").css("opacity", "1");
		$("#dialogroute").css("top", "80px");
	},

	flash: function(icon, html, timer, style) {
		var s = null;
		if (Dialog.flashTimer != null) clearTimeout(Dialog.flashTimer);
		var help = "";

		if (typeof html === "object") {
			help = html.help;
			html = html.message;
		}

		if (style == undefined) s = "dialog-flash";
		else s = style;

		var od = $(s);
		if (od != undefined) od.remove();

		if ($("#dialog_flash")) $("#dialog_flash").remove();

		$("#dialogs").append(TPL.render(s, {message:html, "icon":icon, "help":help}));

		$("#dialog_flash").css("left", $("body").width() * 0.5 - ($("#dialog_flash").width() + 50) * 0.5);
		$("#dialog_flash").removeClass("dialog_notrans");

		$("#dialog_flash").on(Events.pointer.down, Dialog.closeFlash);
		setTimeout(function() {
			$("#dialog_flash").css("opacity", "1");
			$("#dialog_flash").css("top", "80px");
		}, 200);

		if (timer == undefined)
			Dialog.flashTimer = setTimeout(function() {Dialog.closeFlash();}, 8000);
		else 
			Dialog.flashTimer = setTimeout(function() {Dialog.closeFlash();}, timer);
	},

	closeFlash: function() {
		$("#dialog_flash").css("opacity","0");
		Tab.groups["dialogs"].disable();
		setTimeout(function() {
			$("#dialog_flash").hide();
			$("#dialog_flash").addClass("dialog_notrans");
			$("#dialog_flash").css("top", "-80px");
		}, 1000);	
	},

	hint: function(symbol ,icon, html, timer, style) {
		if (!Dialog.hinted.hasOwnProperty(symbol)) {
			Dialog.flash(icon, html, timer, style);
			Dialog.hinted[symbol] = 1;
		}
	},

	okHandler: function() {
		$("#dialog").hide();
		$("#dialog_overlay").hide();
		if (Dialog.afterFunc != null) Dialog.afterFunc();
	},

	optionHandler: function(no, id, evt) {
		$(id).hide();
		$("#dialog_overlay").hide();
		Tab.groups["dialogs"].disable();
		if (Dialog.afterFunc != null) Dialog.afterFunc(no);		

		evt.stopPropagation();
		evt.preventDefault();
	},

	cancel: function(id) {
		$(id).hide();
		$("#dialog_overlay").hide();
		if (Dialog.afterFunc != null) Dialog.afterFunc(-1);
		Tab.groups["dialogs"].disable();
	},

	test: function() {
		Dialog.flash("<img src='/html5/assets/end_white.png'>","Dotarłeś do miejsca przeznaczenia");
	},

	closeDialogs: function() {
		$("#dialog").hide();
		$("#dialog_overlay").hide();
	},

	cookie: function(after) {
		var od = $("#dialog");
		if (od != undefined) od.remove();
	
		Dialog.afterFunc = after;

		var jtext = JSON.parse(PROJECT.settings['cookies/text']);
		var jlink = JSON.parse(PROJECT.settings['cookies/link']);

		var txt = "";
		var url = undefined;
		if (jlink != undefined && jlink[player.lang] != undefined && jlink[player.lang] != "") url = jlink[player.lang];

		if (jtext != undefined && jtext[player.lang] != undefined && jtext[player.lang] != "") txt = jtext[player.lang];
		else txt = TPL.lng("cookie.text");

		$("#dialogs").append(TPL.render("dialog-cookie", {message:txt, url:url, more:TPL.lng("cookie.btn_more"), dismiss:TPL.lng("cookie.btn_dismiss")}));

		$("#dialog").css("left", $("body").width() * 0.5 - ($("#dialog").width() + 50) * 0.5);
		$("#dialog").css("opacity", "1");
		$("#dialog").css("top", "80px");

		Tab.add("dialogs", Tab.simpleTab($("#dialog").find(".bottom .more"), 1), {});		
		Tab.add("dialogs", Tab.simpleTab($("#dialog").find(".bottom .ok"), 2), {});
		Tab.groups["dialogs"].enable();
	}
}

PluginManager.add(Dialog);